import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="bg-orange-100 text-white py-8">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-6 px-10">
        {/* About Section */}
        <div>
          <h2 className="text-xl font-bold mb-2">UMobile Developer Portal</h2>
          <p className="text-white">
            The U Mobile Developer Portal provides developers with access to U
            Mobile's APIs, enabling integration with advanced network
            capabilities like 5G. It offers tools, documentation, and support to
            help build innovative applications.
          </p>
        </div>

        {/* Navigation Links */}
        <div>
          <h2 className="text-xl font-bold mb-2">Quick Links</h2>
          <ul className="space-y-2">
            <li>
              <a
                href="/"
                className="text-white hover:text-gray-100 transition duration-200"
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="/about"
                className="text-white hover:text-gray-100 transition duration-200"
              >
                About
              </a>
            </li>
          </ul>
        </div>

        {/* Social Media Icons */}
        <div>
          <h2 className="text-xl font-bold mb-2">Follow Us</h2>
          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/umobile/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                className="w-6 h-6 text-white hover:text-gray-100 transition duration-200"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M22.675 0h-21.35c-.733 0-1.325.592-1.325 1.325v21.351c0 .732.592 1.324 1.325 1.324h11.495v-9.284h-3.125v-3.622h3.125v-2.672c0-3.1 1.894-4.787 4.658-4.787 1.325 0 2.462.099 2.792.143v3.235h-1.917c-1.504 0-1.795.716-1.795 1.763v2.317h3.59l-.467 3.622h-3.124v9.284h6.127c.732 0 1.324-.592 1.324-1.324v-21.35c0-.733-.592-1.325-1.324-1.325z" />
              </svg>
            </a>

            
          </div>
        </div>

        {/* Contact Info Section */}
        <div>
          <h2 className="text-xl font-bold mb-2">Contact Us</h2>
          <p className="text-white">
            For inquiries, email us at{" "}
            <a
              href="mailto:partners@u.com.my"
              className="text-white hover:text-white transition duration-200 font-bold"
            >
              partners@u.com.my
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
